import styled from "styled-components";

import ContactButtonBox from "src/shared/components/ContactButtonBox";

export const ButtonBox = styled(ContactButtonBox)`
  margin-bottom: 24px;
`;
